/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../../app/base/base.service.ts" />

module Eseebase {
    export class AnalyticsService {
        public trackingId: string;

        constructor(private baseService: BaseService, private $q: ng.IQService, private $window: any, private $rootScope: ng.IRootScopeService, private $location: ng.ILocationService) { }

        public getTrackingId() {
            var d = this.$q.defer();
            if (this.trackingId == null) {
                var vm = this;
                this.baseService.get('google/trackingid').then(f =>  {
                    vm.trackingId = <string>f.data;
                    d.resolve(vm.trackingId);
                });
            }
            else {
                d.resolve(this.trackingId);
            }
            return d.promise;
        }

        public registerEvents() {
            var vm = this;
            this.$window.dataLayer = this.$window.dataLayer || [];
            this.$window.gtag = function gtag() {
                vm.$window.dataLayer.push(arguments);
            }
            this.$window.gtag('js', new Date());

            this.$rootScope.$on("$routeChangeSuccess", function (event, current, previous) {
                var localizedTitle = current.locals.texts.find(t => t.key == current.$$route.title);
                if (localizedTitle != null) {
                    vm.$window.document.title = 'eseeBASE - ' + localizedTitle.value;
                }
                else {
                    vm.$window.document.title = 'eseeBASE - ' + current.$$route.title;
                }

                vm.getTrackingId().then((trackingId) => {
                    if (trackingId != '') {
                        vm.$window.gtag('config', trackingId, {
                            'page_title': current.$$route.title,
                            'page_location': vm.$location.absUrl(),
                            'page_path': vm.$location.path()
                        });
                    }
                });
            });

            this.$rootScope.$on('model-expand-collapse', (event, args) =>
                vm.$window.gtag('event', 'model_expand_details', {
                    'event_category': 'model_upload',
                    'event_label': 'Expand details for file: ' + args.fileId
                })
            );

            this.$rootScope.$on('filter-change', () =>
                vm.$window.gtag('event', 'filter_opt_in', {
                    'event_category': 'filter',
                    'event_label': 'Update view clicked'
                })
            );

            this.$rootScope.$on('filter-delete', (event, args) =>
                vm.$window.gtag('event', 'filter_delete', {
                    'event_category': 'filter',
                    'event_label': 'Filter deleted'
                })
            );

            this.$rootScope.$on('menu-open', (event, args) =>
                vm.$window.gtag('event', 'menu_expand', {
                    'event_category': 'model_upload',
                    'event_label': 'Menu expended for file: ' + args.file.id
                })
            );

            this.$rootScope.$on('loadIndoorData', () =>
                vm.$window.gtag('event', 'tab_click', {
                    'event_category': 'building_data',
                    'event_label': 'Indoor data tab is clicked'
                })
            );

            this.$rootScope.$on('loadOutdoorData', () =>
                vm.$window.gtag('event', 'tab_click', {
                    'event_category': 'building_data',
                    'event_label': 'Outdoor data tab is clicked'
                })
            );

            this.$rootScope.$on('loadFloorplans', () =>
                vm.$window.gtag('event', 'tab_click', {
                    'event_category': 'building_data',
                    'event_label': 'Floor plan tab is clicked'
                })
            );

            this.$rootScope.$on('loadMainDrawings', () =>
                vm.$window.gtag('event', 'tab_click', {
                    'event_category': 'building_data',
                    'event_label': 'Main drawings tab is clicked'
                })
            );

            this.$rootScope.$on('loadScannedImages', () =>
                vm.$window.gtag('event', 'tab_click', {
                    'event_category': 'building_data',
                    'event_label': 'Scanned images tab is clicked'
                })
            );

            this.$rootScope.$on('login', () => vm.$window.gtag('event', 'login'));

            this.$rootScope.$on('model-upload', () =>
                vm.$window.gtag('event', 'model_upload', {
                    'event_category': 'model_upload',
                    'event_label': 'Uploading a new model'
                })
            );

            this.$rootScope.$on('rerun-model', () =>
                vm.$window.gtag('event', 'model_rerun', {
                    'event_category': 'model_upload',
                    'event_label': 'Re-runing model'
                })
            );

            this.$rootScope.$on('correction-saved', () =>
                vm.$window.gtag('event', 'correction_saved', {
                    'event_category': 'floorplan_correction',
                    'event_label': 'Correction saved'
                })
            );
        }
    }

    AnalyticsService.$inject = ['BaseService', '$q', '$window', '$rootScope', '$location'];
    angular
        .module('eseebase')
        .service('AnalyticsService', AnalyticsService);
}